import { Menu, Phone } from 'lucide-react';
import { Wordmark } from '@/Components/Wordmark';

/**
 * Mobile-only top bar. Hamburger + wordmark + tap-to-call. Hidden on
 * md and up where the desktop {@link Header} takes over.
 *
 *   <MobileHeader phone="1-833-INJURY-1" onMenuClick={openSheet} />
 */

export interface MobileHeaderProps {
    phone: string;
    onMenuClick?: () => void;
    className?: string;
}

function telHref(number: string): string {
    return 'tel:' + number.replace(/[^0-9+]/g, '');
}

export function MobileHeader({
    phone,
    onMenuClick,
    className,
}: MobileHeaderProps) {
    const cls = [
        'flex md:hidden items-center justify-between',
        'h-14 px-4 bg-card border-b border-rule',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <nav className={cls} aria-label="Mobile site navigation">
            <button
                type="button"
                onClick={onMenuClick}
                aria-label="Open navigation menu"
                className="inline-flex items-center justify-center size-10 rounded-md hover:bg-paper-deep"
            >
                <Menu size={20} aria-hidden="true" />
            </button>
            <a href="/" className="inline-flex" aria-label="injury.help home">
                <Wordmark size={18} />
            </a>
            <a
                href={telHref(phone)}
                aria-label={`Call ${phone}`}
                className="inline-flex items-center justify-center size-10 rounded-md text-ember hover:bg-ember-tint"
            >
                <Phone size={20} aria-hidden="true" />
            </a>
        </nav>
    );
}

export default MobileHeader;
